import * as React from "react";

import "./style.scss";
import "react-alice-carousel/lib/scss/alice-carousel.scss";

import { Box } from "@mui/material";
import { ProductDetailSkeleton } from "../../../../components/skeletons/AppPageSkeletons";
import { useMediaQuery } from "react-responsive";
import chat from "../../../../assets/Images/chat.png";
import { useNavigate } from "react-router";

import BackButton from "../../../../components/buttons/BackButton";
import { useSizeDetail } from "./useSizeDetail";
import { useAvailabilityMonths } from "./hooks/useAvailabilityMonths";
import { useItemDetailCartActions } from "./hooks/useItemDetailCartActions";
import { useItemDetailPcs } from "./hooks/useItemDetailPcs";
import { useItemDetailPricing } from "./hooks/useItemDetailPricing";
import { useProductDetailFormatters } from "./hooks/useProductDetailFormatters";
import { useSpecificationDimension } from "./hooks/useSpecificationDimension";
import DetailCarousel from "./DetailCarousel";
import PriceSection from "./PriceSection";
import ChooseSizeSection from "./ChooseSizeSection";
import SpecificationSection from "./SpecificationSection";
import AvailabilitySection from "./AvailabilitySection";
import QuantitySection from "./QuantitySection";
import ContactAndCtaSection from "./ContactAndCtaSection";

const ItemDetail = () => {
  const { infoDetail, loading } = useSizeDetail();
  const [indexImg, setIndexImg] = React.useState(0);
  const [count, setCount] = React.useState("1");

  const {
    priceItem,
    regularPriceNumber,
    salePriceNumber,
    hasPrice,
    hasSale,
  } = useItemDetailPricing(infoDetail);
  const dimensionText = useSpecificationDimension(infoDetail);
  const { formatMoneyData, formatQuantityData } = useProductDetailFormatters();
  const { isPlants, pcsPerUnitResolved } = useItemDetailPcs(infoDetail);
  const { getMonthName } = useAvailabilityMonths();
  const { onAddToCart, onViewCart, onMobileAddToCart } = useItemDetailCartActions(
    infoDetail,
    count,
    priceItem,
  );

  const navigate = useNavigate();
  const isIphone = useMediaQuery({
    query: "(max-width: 600px)",
  });

  if (loading) {
    return <ProductDetailSkeleton />;
  }
  return (
    <React.Fragment>
      <BackButton />
      <Box
        className="main-detail"
        sx={{
          display: {
            sm: "block",
            md: "flex",
            marginBottom: 40,
          },
        }}>
        <DetailCarousel
          images={infoDetail?.images}
          isNarrowViewport={Boolean(isIphone)}
          indexImg={indexImg}
          onChangeIndex={setIndexImg}
          imageAltPrefix={infoDetail?.product_name}
        />
        <Box className="info-product-detail" sx={{ padding: { xs: "10px" } }}>
          <PriceSection
            productName={infoDetail?.product_name}
            regularPriceNumber={regularPriceNumber}
            salePriceNumber={salePriceNumber}
            hasPrice={hasPrice}
            hasSale={hasSale}
            formatMoneyData={formatMoneyData}
          />

          <ChooseSizeSection
            show={infoDetail?.category_id === 1}
            currentSizeId={infoDetail?.id}
            otherSizes={infoDetail?.other_sizes}
            onNavigateSize={(productId, sizeId) => {
              navigate(`/product-details/${productId}`, {
                replace: true,
                state: { product_id: productId, size_id: sizeId },
              });
            }}
          />

          <SpecificationSection text={dimensionText} />

          <AvailabilitySection
            quantities={infoDetail?.quantity_available as any}
            getMonthName={getMonthName}
            formatQuantityData={formatQuantityData}
          />

          <QuantitySection
            isPlants={isPlants}
            isIphone={Boolean(isIphone)}
            count={count}
            onChangeCount={setCount}
            pcsPerUnit={pcsPerUnitResolved}
            formatQuantityData={formatQuantityData}
          />

          <ContactAndCtaSection
            isPlants={isPlants}
            isIphone={Boolean(isIphone)}
            chatImg={chat}
            onAddToCart={onAddToCart}
            onViewCart={onViewCart}
            onMobileAddToCart={onMobileAddToCart}
          />
        </Box>
      </Box>
    </React.Fragment>
  );
};
export default ItemDetail;
